export enum AuthFormName {
  LOGIN = 'login',
  REGISTER_FIND = 'registerFindUser',
  REGISTER_CREATE = 'registerCreateUser',
  REGISTER_VERIFY = 'registerVerifyUser',
  FIND_USERNAME = 'forgotUsernamePersonalDetails',
  FORGOT_CONTACT_INFO = 'forgotUsernameContactInfo',
  FORGOT_PASSWORD = 'forgotPassword',
  RESET_PASSWORD = 'resetPassword',
  PROFILE_VEHICLE_EDIT = 'vehicleEdit',
  PROFILE_RESIDENCE_EDIT = 'residenceEdit',
  PROFILE_INCOME_EDIT = 'incomeEdit',
  CARD_SECOND_LEVEL_VERIFICATION = 'cardSecondLevelVerification',
  PAPERLESS_ENROLLMENT = 'paperlessEnrollment',
  PAPERLESS_DECLINE = 'paperlessDecline',
  PAPERLESS_MAYBE_LATER = 'paperlessMaybeLater',
  UPDATE_EMAIL_ADDRESS = 'updateEmailAddress',
}

export enum AuthFormType {
  LOGIN = 'login',
  PROFILE = 'profile',
  PAPERLESS_ENROLLMENT_INTERSTITIAL = 'paperlessEnrollmentInterstitial',
  CARD_SECOND_LEVEL_VERIFICATION = 'cardSecondLevelVerification',
  RESET_PASSWORD = 'resetPassword',
}

export enum AuthFormFieldName {
  CARD_VERIFICATION_NUMBER = 'cardVerificationNumber',
  USERNAME = 'username',
  PASSWORD = 'password',
  CONFIRM_PASSWORD = 'confirmPassword',
  LAST_NAME = 'lastName',
  LAST_SIX_SSN = 'lastSixSSN',
  DOB = 'dob',
  SMS_OPT_IN = 'smsOptIn',
  EMAIL_OPT_IN = 'emailOptIn',
  ACCEPT_TERMS = 'acceptTerms',
  CONFIRMATION_CODE = 'confirmationCode',
  CONTACT_INFO = 'contactInfo',
  RECAPTCHA = 'recaptcha',
  PRIMARY_VEHICLE_OWNERSHIP_STATUS = 'primaryVehicleOwnershipStatus',
  PRIMARY_VEHICLE_MAKE = 'primaryMake',
  PRIMARY_VEHICLE_MODEL = 'primaryModel',
  PRIMARY_VEHICLE_YEAR = 'primaryYear',
  PRIMARY_VEHICLE_VIN = 'primaryVin',
  SECONDARY_VEHICLE_OWNERSHIP_STATUS = 'secondaryOwnershipStatus',
  SECONDARY_VEHICLE_MAKE = 'secondaryMake',
  SECONDARY_VEHICLE_MODEL = 'secondaryModel',
  SECONDARY_VEHICLE_YEAR = 'secondaryYear',
  SECONDARY_VEHICLE_VIN = 'secondaryVin',
  RESIDENCE_OWNERSHIP_STATUS = 'residenceOwnershipStatus',
  RESIDENCE_MONTHLY_PAYMENT = 'monthlyPayment',
  INDIVIDUAL_INCOME = 'individualIncome',
  HOUSEHOLD_INCOME = 'householdIncome',
  EMPLOYMENT_STATUS = 'employmentStatus',
  PAPERLESS_OPT_IN = 'paperlessOptIn',
  EMAIL = 'email',
}

export enum AuthLinkType {
  FORGOT_USER_PASS = 'initiateForgotUserPass',
  REGISTER = 'initiateRegister',
  CONTINUE_APP = 'initiateContinueApplication',
  NAV_TO_PAPERLESS_PROFILE = 'initiateNavigationToPaperlessProfile',
  NAV_TO_LOAN_PAYMENT = 'initiateNavigationToMakeALoanPayment',
  NAV_TO_CARD_PAYMENT = 'initiateNavigationToMakeACardPayment',
  NAV_TO_LOAN_AUTOPAY = 'initiateNavigationToLoanAutoPayment',
  NAV_TO_LOGIN = 'navigateBackToLogin',
  NAV_TO_BEFH = 'navigateToBEFH',
  NAV_TO_CREDIT_MANAGER = 'redirectToCreditManager',
  NAV_TO_DEBT_MANAGER = 'redirectToDebtManager',
  NAV_TO_MONEY_MANAGER = 'redirectToMoneyManager',
  NAV_TO_FORGOT_USERNAME = 'navigateBackToForgotUsername',
  NAV_TO_FORGOT_PASSWORD = 'navigateToForgotPassword',
  NAV_TO_OFFERS = 'navigateToOffers',
  CONF_CODE_HELP = 'confirmationCodeHelp',
  NAV_TO_REGISTRATION = 'navigateToRegistration',
  NAV_TO_PROFILE = 'navigateToProfile',
  NAV_TO_INCOME = 'navigateToProfileIncome',
  NAV_TO_RESIDENCE = 'navigateToProfileResidence',
  PROFILE_LOOKS_GOOD = 'profileLooksGoodClick',
  PROFILE_UPDATE_INFO = 'profileUpdateInfo',
  PROFILE_DELETE_SECONDARY_VEHICLE = 'profileDeleteSecondaryVehicle',
  PROFILE_ADD_SECONDARY_VEHICLE = 'profileAddSecondaryVehicle',
  PROFILE_CANCEL_EDIT = 'profileCancelEdit',
  PROFILE_SAVE = 'profileSaveEdit',
  PROFILE_CONFIRM_CANCEL = 'profileConfirmModalCancel',
  NAV_TO_CHANGE_DUE_DATE = 'initiateNavigationToChangeDueDate',
  OPEN_HSL_SLIDE_OUT = 'openHslSlideOut',
}
